export var FilterActionKind;
(function (FilterActionKind) {
    FilterActionKind["FILTER_IGNORED"] = "FILTER_IGNORED";
    FilterActionKind["FiLTER_STATUS"] = "FILTER_STATUS";
    FilterActionKind["FILTER_MINIMUM_DETECTIONS"] = "FILTER_MINIMUM_DETECTING";
    FilterActionKind["FILTER_DOMAIN"] = "FILTER_DOMAIN";
    FilterActionKind["CLEAR_ALL_FILTERS"] = "CLEAR_ALL_FILTERS";
    FilterActionKind["CLEAR_FIELD_FILTERS"] = "CLEAR_FIELD_FILTERS";
})(FilterActionKind || (FilterActionKind = {}));
export const FilterReducer = (state, action) => {
    switch (action.type) {
        case FilterActionKind.FILTER_IGNORED:
            return { ...state, ignored: action.payload };
        case FilterActionKind.FiLTER_STATUS:
            return { ...state, status: action.payload };
        case FilterActionKind.FILTER_MINIMUM_DETECTIONS:
            return { ...state, minimum_detections: action.payload };
        case FilterActionKind.FILTER_DOMAIN:
            return { ...state, domain: action.payload };
        case FilterActionKind.CLEAR_ALL_FILTERS:
            return {};
        case FilterActionKind.CLEAR_FIELD_FILTERS:
            delete state[action.payload];
            return { ...state };
        default:
            return state;
    }
};
